import React from 'react';
import { NavLink } from 'react-router-dom';

import ExternalLink from 'shared/components/ExternalLink';
import styles from './styles.module.scss';

export const NavItem = ({
  id,
  url,
  title,
  externalUrl,
  onClickExtra = () => {
    return;
  },
  closeAction = () => {
    return;
  },
  closeNavigation = () => {
    return;
  }
}) => {
  return (
    <div className={styles.item}>
      {url && (
        <span
          onClick={() => {
            onClickExtra();
            closeNavigation();
            closeAction();
          }}>
          <NavLink
            id={id}
            to={url}
            className={styles.title}
            activeClassName={styles.active}>
            {title}
          </NavLink>
        </span>
      )}
      {externalUrl && (
        <ExternalLink id={id} className={styles.title} href={externalUrl}>
          {title}
        </ExternalLink>
      )}
    </div>
  );
};
